export default __webpack_public_path__ + "static/brand-logo-toby-a49dd012417ed7925e0d920c5b630bb3.png";